import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './curve-builder-paths';
import { curveBuilderApp } from './curve-builder';
import { curveAllHandler, curveCreatedHandler } from 'built-in-apps-shared';

export const CurveBuilderApp: SpherePlatformApp = {
    APP: curveBuilderApp,
    PATHS,
    NOTIFICATION_EVENT_HANDLERS: [curveCreatedHandler, curveAllHandler]
};
